import { vappContainer } from '@/application';
import { logger as log } from '@common/logger';
import { SignInPageService } from '@pages/SignInPage/services';

const MODULE_NAME = 'Register.machines.states.getPage';

const getSrv = () => {
  return vappContainer.get<SignInPageService>(SignInPageService.displayName);
};

export const getPageContent = async (context: any, event: any) => {
  const currentState = 'GET_PAGE_CONTENT';
  const method = 'getPageContent';

  return new Promise(async (resolve, reject) => {
    try {
      log.log(MODULE_NAME, 'context: ', context, 'event: ', event);
      const srv = getSrv();
      const content = await srv.agent?.getStaticPageContentSync();

      if (content) {
        return resolve({
          key: 'RENDER_PAGE',
          value: {
            ...(content || {}),
          },
        });
      } else {
        const msg = 'Page content not found';
        log.error(MODULE_NAME, `error in ${method}, msg: ${msg}`);
        return reject({
          key: 'RENDER_PAGE_ERROR',
          value: msg,
        });
      }
    } catch (err: any) {
      log.error(MODULE_NAME, `error in ${method}, msg: ${err?.message}`);
      return reject({
        key: 'RENDER_PAGE_ERROR',
        value: err?.message,
      });
    }
  });
};
